import React, { useEffect, useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useGlobalContext } from "../../Context/GlobalContext";
import Loading from "../../Extra/Loading";
import { formatDateToDis, getCurrentDate } from "../../Utilitie";
import { IoMdArrowDropdown, IoMdArrowDropup } from "react-icons/io";
const OpTransReport = () => {
  const [interChangeData, setInterChangeData] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const { globalDate, setDateForGlobal } = useGlobalContext();
  const [interchangeDates, setInterChangeDates] = useState(null);
  const [reordered, setReordered] = useState({});
  const [date, setDate] = useState(null);
  const currentDate = getCurrentDate();

  const url = `${process.env.REACT_APP_URL_PREFIX}interchange/date?date=${globalDate}`;

  const handleDateChange = (event) => {
    const inputDate = event.target.value; // YYYY-MM-DD
    setDate(inputDate);
    const [year, month, day] = inputDate.split("-");
    const formattedDate = `${day}-${month}-${year}`;
    setDateForGlobal(inputDate);
  };
  const fetchData = async (url) => {
    setLoading(true);
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${localStorage.token}`,

          "Content-Type": "application/json",
        },
      });
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const data = await response.json();

      setInterChangeData(data.data);
      setInterChangeDates(data.date);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
      setError(false);
    }
  };
  useEffect(() => {
    fetchData(url);
  }, [globalDate]);
  useEffect(() => {
    if (!interchangeDates) return;

    const desiredOrder = [
      "LastYear_date",
      "Input_date",
      "Previous_week",
      "Current_week",
      "Previous_month",
      "Current_month",
      "Last_financial_year",
      "Current_financial_year",
    ];

    const temp = {};

    for (const key of desiredOrder) {
      const matchKey = Object.keys(interchangeDates).find(
        (k) => k.toLowerCase() === key.toLowerCase()
      );
      if (matchKey !== undefined) {
        temp[key] = interchangeDates[matchKey];
      }
    }

    setReordered(temp);
  }, [interchangeDates]);

  const thStyle = { border: "1px solid white" };
  // const oldYearStyle = { background: "rgba(110, 136, 123, 0.42)" };
  // const currentYearStyle = { background: "rgba(66, 151, 145, 0.42)" };
  const oldYearStyle = { background: "rgba(211, 50, 50, 0.29)" };
  const currentYearStyle = { background: "rgba(41, 165, 236, 0.53)" };
  return (
    <div className="">
      <div className="d-flex justify-content-between">
        <div>
          <h6> Transaction Report date : {formatDateToDis(globalDate)}</h6>
        </div>
        <form>
          <input
            type="date"
            value={date}
            onChange={(e) => {
              handleDateChange(e);
            }}
            max={currentDate}
          />
        </form>
      </div>

      <div className="row">
        <div className="col-md-12">
          <div className="table-responsive">
            {/* <SplineChart data={chartData} categories={chartCategories} /> */}
            {loading ? <Loading /> : null}
            <table
              className="table newUiTable table-striped table-hover p-0 m-0"
              style={{ fontSize: "11.5px", fontWeight: "bold" }}
            >
              <thead>
                <tr>
                  <th
                    rowSpan={2}
                    style={{
                      textAlign: "center",
                      verticalAlign: "middle",
                      border: "1px solid white",
                    }}
                  >
                    Indices
                  </th>
                  <th style={thStyle} colSpan={3}>
                    Day
                  </th>
                  <th style={thStyle} colSpan={3}>
                    Weekly
                  </th>
                  <th style={thStyle} colSpan={3}>
                    Monthly
                  </th>
                  <th style={thStyle} colSpan={3}>
                    Yearly
                  </th>
                  <th
                    scope="col"
                    rowSpan={2}
                    style={{
                      textAlign: "center",
                      verticalAlign: "middle",
                      border: "1px solid white",
                    }}
                  >
                    Max
                  </th>
                </tr>

                <tr
                  style={{ textAlign: "center", verticalAlign: "middle" }}
                  className="p-0 m-0"
                >
                  {/* <th
                    style={{ textAlign: "center", verticalAlign: "middle" }}
                    scope="col"
                  >
                    Indices
                  </th> */}
                  {reordered &&
                    Object.entries(reordered).map(([dateName, date], index) => {
                      return (
                        <React.Fragment>
                          <OverlayTrigger
                            key={index}
                            placement="top"
                            overlay={
                              <Tooltip id={`tooltip-${index}`}>
                                {dateName.replaceAll("_", " ")}
                              </Tooltip>
                            }
                          >
                            <th
                              scope="col"
                              className="align-item-center text-center text-wrap"
                              style={{
                                border: "1px solid white",
                                maxWidth: "70px",
                                fontSize: "11px",
                              }}
                            >
                              {date?.length == 10
                                ? formatDateToDis(date)
                                    ?.replace("-", "/")
                                    .replace("-", "/")
                                : `${formatDateToDis(date?.slice(0, 10))} 
                                 ${formatDateToDis(date?.slice(13, 23))}`}
                            </th>
                          </OverlayTrigger>
                          {index % 2 > 0 ? <th>Variation %</th> : null}
                        </React.Fragment>
                      );
                    })}
                </tr>
                {/* <tr className="p-0 m-0">
                <th scope="col">Indices</th>
                <th scope="col">Today</th>
                <th scope="col">Y-Day</th>
                <th scope="col">Cumm-Y</th>
                <th scope="col">Cumm-LY</th>
                <th scope="col">Max</th>
              </tr> */}
              </thead>

              <tbody>
                {interChangeData &&
                  Object.entries(interChangeData).map(([key, value], index) => {
                    const formatValue = (val, isDecimal) => {
                      const num = Number(val);
                      return isNaN(num)
                        ? "-"
                        : isDecimal
                        ? num.toFixed(1)
                        : Math.trunc(num);
                    };

                    const isWTR = key === "WTR";

                    const getVariation = (curr, prev) => {
                      const currVal = Number(formatValue(curr, isWTR));
                      const prevVal = Number(formatValue(prev, isWTR));
                      if (isNaN(currVal) || isNaN(prevVal) || prevVal === 0)
                        return "-";
                      return (((currVal - prevVal) / prevVal) * 100).toFixed(2);
                    };

                    const getVariationCellStyle = (variation) => {
                      const positive = Number(variation) > 0;
                      const background = positive
                        ? isWTR
                          ? "#ff6666"
                          : "rgb(37, 248, 65)"
                        : isWTR
                        ? "rgb(37, 248, 65)"
                        : "#ff6666";
                      const color = positive
                        ? isWTR
                          ? "white"
                          : "black"
                        : isWTR
                        ? "black"
                        : "white";
                      return {
                        background,
                        color,
                        borderRadius: "3px",
                        padding: "2px 4px",
                        textAlign: "center",
                      };
                    };

                    const varDay = getVariation(value?.Today, value?.Y_Day);
                    const varWeek = getVariation(
                      value?.curr_week_commu,
                      value?.prev_week_commu
                    );
                    const varMonth = getVariation(
                      value?.curr_month_commu,
                      value?.prev_month_commu
                    );
                    const varYear = getVariation(value?.Cumm_Y, value?.Cumm_LY);

                    return (
                      <tr key={index}>
                        <td>{key}</td>
                        <td style={oldYearStyle}>
                          {formatValue(value?.Y_Day, isWTR)}
                        </td>
                        <td style={currentYearStyle}>
                          {formatValue(value?.Today, isWTR)}
                        </td>
                        <td>
                          <div style={getVariationCellStyle(varDay)}>
                            {varDay > 0 ? (
                              <IoMdArrowDropup />
                            ) : (
                              <IoMdArrowDropdown />
                            )}
                            {varDay}
                          </div>
                        </td>

                        <td style={oldYearStyle}>
                          {formatValue(value?.prev_week_commu, isWTR)}
                        </td>
                        <td style={currentYearStyle}>
                          {formatValue(value?.curr_week_commu, isWTR)}
                        </td>
                        <td>
                          <div style={getVariationCellStyle(varWeek)}>
                            {varWeek > 0 ? (
                              <IoMdArrowDropup />
                            ) : (
                              <IoMdArrowDropdown />
                            )}
                            {varWeek}
                          </div>
                        </td>

                        <td style={oldYearStyle}>
                          {formatValue(value?.prev_month_commu, isWTR)}
                        </td>
                        <td style={currentYearStyle}>
                          {formatValue(value?.curr_month_commu, isWTR)}
                        </td>
                        <td>
                          <div style={getVariationCellStyle(varMonth)}>
                            {varMonth > 0 ? (
                              <IoMdArrowDropup />
                            ) : (
                              <IoMdArrowDropdown />
                            )}
                            {varMonth}
                          </div>
                        </td>

                        <td style={oldYearStyle}>
                          {formatValue(value?.Cumm_LY, isWTR)}
                        </td>
                        <td style={currentYearStyle}>
                          {formatValue(value?.Cumm_Y, isWTR)}
                        </td>
                        <td>
                          <div style={getVariationCellStyle(varYear)}>
                            {varYear > 0 ? (
                              <IoMdArrowDropup />
                            ) : (
                              <IoMdArrowDropdown />
                            )}
                            {varYear}
                          </div>
                        </td>

                        <td style={{ fontWeight: "bold" }}>
                          {formatValue(value?.Max, isWTR)}
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>

          {/* <div className="col-md-3">3</div>
        <div className="col-md-3">4</div> */}
        </div>
      </div>
      {/* Pass data and categories as props */}
    </div>
  );
};
export default OpTransReport;
